export interface CoachItem {
  title: string;
  minutes: number;
  actionType: "today" | "drill" | "exam" | "open_chapter" | "review_section";
  chapterId?: string;
  anchor?: string;
}

export interface CoachDay {
  day: number;
  date: string;
  focus: string;
  items: CoachItem[];
}

export interface CoachResponse {
  generatedAt: string;
  daysToExam: number | null;
  plan: CoachDay[];
  rationale: string;
  model?: string;
  cached?: boolean;
}

export async function fetchCoach(refresh = false): Promise<CoachResponse> {
  const res = await fetch(refresh ? "/api/coach?refresh=1" : "/api/coach", { credentials: "include" });
  if (!res.ok) {
    let body: any = null;
    try { body = await res.json(); } catch { /* ignore */ }
    const err = new Error(body?.error ?? `http_${res.status}`);
    (err as any).body = body;
    (err as any).status = res.status;
    throw err;
  }
  return (await res.json()) as CoachResponse;
}

export async function saveExamDate(examDate: string | null): Promise<{ ok: boolean }> {
  const res = await fetch("/api/coach", {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ examDate }),
  });
  if (!res.ok) throw new Error(`save_exam_date_${res.status}`);
  return (await res.json()) as { ok: boolean };
}

export function actionHref(item: CoachItem): string {
  switch (item.actionType) {
    case "today": return "/today";
    case "drill": return "/drill";
    case "exam": return "/exam";
    case "open_chapter":
    case "review_section":
      return item.chapterId ? `/chapter/${item.chapterId}` : "/";
  }
}
